import DictionaryItem from "../../../model/dictionary/DictionaryItem";

/**
 * Categories fetched action
 */
export const CATEGORIES_FETCHED = "CATEGORIES_FETCHED";
export type CATEGORIES_FETCHED = { categories: DictionaryItem[] };

/**
 * Category created action
 */
export const CATEGORY_CREATED = "CATEGORY_CREATED";
export type CATEGORY_CREATED = { category: DictionaryItem };

/**
 * Category updated action
 */
export const CATEGORY_UPDATED = "CATEGORY_UPDATED";
export type CATEGORY_UPDATED = { category: DictionaryItem };

/**
 * Categories sort order updated action
 */
export const CATEGORY_SORT_ORDER_UPDATED = "CATEGORY_SORT_ORDER_UPDATED";
export type CATEGORY_SORT_ORDER_UPDATED = { categories: DictionaryItem[] };
